"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Img = exports.ContainerModalImg = exports.ContainerLoading = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: grid;\n  place-items: center;\n  width: ", ";\n  min-width: min-content;\n\n  .container-modal {\n    .container-background {\n      background-color: rgba(0, 0, 0, 0.7);\n    }\n  }\n"])), function (_ref) {
  var width = _ref.width;
  return width ? width : "min-content";
});

exports.Container = Container;

var ContainerModalImg = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  background-color: transparent;\n\n  .container-header {\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n    padding: 8px 10px;\n\n    .container-btnDownload {\n      width: 28px;\n      height: 28px;\n      overflow: hidden;\n      display: grid;\n      place-items: center;\n    }\n  }\n\n  .container-imgModal {\n    width: 100%;\n    height: 100%;\n\n    .img {\n      width: 100%;\n      max-height: 100vh;\n      object-fit: contain;\n    }\n  }\n"])));

exports.ContainerModalImg = ContainerModalImg;

var ContainerLoading = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  display: grid;\n  place-items: center;\n  min-width: min-content;\n  font-size: ", "px;\n  color: ", ";\n  padding: 5px;\n"])), function (_ref2) {
  var sizeLoading = _ref2.sizeLoading;
  return sizeLoading ? sizeLoading : "30";
}, function (_ref3) {
  var colorLoading = _ref3.colorLoading;
  return colorLoading ? colorLoading : "#9e2674";
});

exports.ContainerLoading = ContainerLoading;

var Img = _styledComponents.default.img(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  display: ", ";\n  width: 100%;\n  cursor: pointer;\n  object-fit: contain;\n"])), function (_ref4) {
  var show = _ref4.show;
  return show ? "grid" : "none";
});

exports.Img = Img;